// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ERmah","delete":"styles_delete__2F78R","update":"styles_update__2tRh0","add":"styles_add__2IJ9C"};